
// region JS Imports

// region External Modules
import $ from "jquery"

import { EventEmitter } from "events"
// endregion External Modules

// region Private Modules
import {
  q_ajax_3,
} from "app/utils/q_ajax/q_ajax_3"
import NumbersFormatter from "app/numbers/formatter"

import dayjs from "plugins/dayjs/index"
import * as Routes from "plugins/js-routes"
import DataRetriever from "app/data_retriever"
import I18n from "plugins/i18n-js"
import Highcharts from "plugins/highcharts"
// endregion Private Modules

// region Public Components
// endregion Public Components

// region Private Components
import {
  Factory as MonthRangeSelectMenuFactory,
  MonthRangeSelectMenu,
} from "./filter_bar/month_range_select_menu/index"

import {
  Factory as CompareSectionFactory,
  CompareSection,
} from "./compare_section/index"

import BarChart from "./highcharts/bar_chart/index"
import LineGraph from "./highcharts/line_graph/index"
import PieChart from "./highcharts/pie_chart"
// endregion Private Components

// endregion JS Imports



interface Selector {
  scope:          string
  duration_item:  string

  market_overview:              string
  average_price_per_net_area:   string
  total_number_of_transactions: string
  total_turnover:               string
  suffix:                       string

  price_per_sqft_value_percentage_change: string
  total_transactions_percentage_change:   string
  total_turnover_percentage_change:       string

  bar_chart_container:           string
  line_graph_container:          string
  range_selector_container:      string

  line_graph_compare_series_text:   string
  line_graph_compare_series_symbol: string
  bar_chart_compare_series_symbol:  string

  economic_indicator_label:       string
  economic_indicator_label_text:  string

  pie_charts_container:  string
  pie_chart_container:   string
}

interface InputSelector {
  scope?:          string
  duration_item?:  string

  market_overview?:              string
  average_price_per_net_area?:   string
  total_number_of_transactions?: string
  total_turnover?:               string
  suffix?:                       string

  price_per_sqft_value_percentage_change?: string
  total_transactions_percentage_change?:   string
  total_turnover_percentage_change?:       string

  bar_chart_container?:           string
  line_graph_container?:          string
  range_selector_container?:      string

  line_graph_compare_series_text?:   string
  line_graph_compare_series_symbol?: string
  bar_chart_compare_series_symbol?:  string

  economic_indicator_label?:      string
  economic_indicator_label_text?: string

  pie_charts_container?:  string
  pie_chart_container?:   string
}

const DEFAULT_SELECTOR = {
  scope:          ".page--building-level-real-estate-transactions-page--filter-bar-desktop",
  duration_item:  ".page--building-level-real-estate-transactions-page--filter-bar-desktop-option",

  market_overview:              ".page--building-level-real-estate-transactions-page--market-data-overview",
  average_price_per_net_area:   ".page--building-level-real-estate-transactions-page--market-data-overview__tile__content_price_per_sqft_value",
  total_number_of_transactions: ".page--building-level-real-estate-transactions-page--market-data-overview__tile__total-transactions",
  total_turnover:               ".page--building-level-real-estate-transactions-page--market-data-overview__tile__total-turnover",
  suffix:                       ".page--building-level-real-estate-transactions-page--market-data-overview__tile__content__value_suffix",

  price_per_sqft_value_percentage_change: ".page--building-level-real-estate-transactions-page--market-data-overview__tile__title-price_per_sqft_value-percentage-change",
  total_transactions_percentage_change:   ".page--building-level-real-estate-transactions-page--market-data-overview__tile__title-total-transactions-percentage-change",
  total_turnover_percentage_change:       ".page--building-level-real-estate-transactions-page--market-data-overview__tile__title-total_turnover-percentage-change",

  bar_chart_container:          ".page--building-level-real-estate-transactions-page--market-data-overview--bar_chart",
  line_graph_container:         ".page--building-level-real-estate-transactions-page--market-data-overview--line_graph",
  range_selector_container:     ".page--building-level-real-estate-transactions-page--market-data-overview--range_selector_container",

  line_graph_compare_series_text:   ".page--building-level-real-estate-transactions-page--market-data-overview--custom-legend-line_graph--compared-series-text",
  line_graph_compare_series_symbol: ".page--building-level-real-estate-transactions-page--market-data-overview--custom-legend-line_graph--compared-series-symbol",
  bar_chart_compare_series_symbol:  ".page--building-level-real-estate-transactions-page--market-data-overview--custom-legend-bar_graph--compared-series-symbol",

  economic_indicator_label:       ".page--building-level-real-estate-transactions-page--market-data-overview--line_graph-yAxis-economic-indicator-label",
  economic_indicator_label_text:  ".page--building-level-real-estate-transactions-page--market-data-overview--line_graph-yAxis-economic-indicator-label-text",

  pie_charts_container: ".page--building-level-real-estate-transactions-page--market-data-overview-desktop--pie-charts",
  pie_chart_container:  ".page--building-level-real-estate-transactions-page--market-data-overview-desktop--pie-chart-container",
}

let line_graph: any
let bar_chart: any

class MarketDataOverview extends EventEmitter {
  protected selector: Selector

  protected $scope:          JQuery
  protected $duration_item:  JQuery

  protected month_range_select_menu:  MonthRangeSelectMenu
  protected compare_section:          CompareSection

  protected $market_overview:               JQuery
  protected $average_price_per_net_area:    JQuery
  protected $total_number_of_transactions:  JQuery
  protected $total_turnover:                JQuery
  protected $suffix:                        JQuery

  protected $price_per_sqft_value_percentage_change: JQuery
  protected $total_transactions_percentage_change:   JQuery
  protected $total_turnover_percentage_change:       JQuery

  protected $bar_chart_container:       JQuery
  protected $line_graph_container:      JQuery
  protected $range_selector_container:  JQuery

  protected $line_graph_compare_series_text:   JQuery
  protected $line_graph_compare_series_symbol: JQuery
  protected $bar_chart_compare_series_symbol:  JQuery

  protected $economic_indicator_label:      JQuery
  protected $economic_indicator_label_text: JQuery

  protected $pie_charts_container:  JQuery
  protected $pie_chart_container:   JQuery


  constructor(selector?: InputSelector){
    super()

    this.selector = Object.assign({}, DEFAULT_SELECTOR, selector)

    this.$scope = $(this.selector.scope)
    this.$duration_item = this.$scope.find(this.selector.duration_item)

    this.month_range_select_menu = MonthRangeSelectMenuFactory.instance()
    this.compare_section = CompareSectionFactory.instance()

    this.$market_overview = $(this.selector.market_overview)
    this.$average_price_per_net_area = this.$market_overview.find(this.selector.average_price_per_net_area)
    this.$total_number_of_transactions = this.$market_overview.find(this.selector.total_number_of_transactions)
    this.$total_turnover = this.$market_overview.find(this.selector.total_turnover)
    this.$suffix = this.$market_overview.find(this.selector.suffix)

    this.$price_per_sqft_value_percentage_change = this.$market_overview.find(this.selector.price_per_sqft_value_percentage_change)
    this.$total_transactions_percentage_change = this.$market_overview.find(this.selector.total_transactions_percentage_change)
    this.$total_turnover_percentage_change = this.$market_overview.find(this.selector.total_turnover_percentage_change)

    this.$bar_chart_container = this.$market_overview.find(this.selector.bar_chart_container)
    this.$line_graph_container = this.$market_overview.find(this.selector.line_graph_container)
    this.$range_selector_container = this.$market_overview.find(this.selector.range_selector_container)

    this.$line_graph_compare_series_text = this.$market_overview.find(this.selector.line_graph_compare_series_text)
    this.$line_graph_compare_series_symbol = this.$market_overview.find(this.selector.line_graph_compare_series_symbol)
    this.$bar_chart_compare_series_symbol = this.$market_overview.find(this.selector.bar_chart_compare_series_symbol)

    this.$economic_indicator_label = this.$market_overview.find(this.selector.economic_indicator_label)
    this.$economic_indicator_label_text = this.$market_overview.find(this.selector.economic_indicator_label_text)

    this.$pie_charts_container = this.$market_overview.find(this.selector.pie_charts_container)
    this.$pie_chart_container = this.$market_overview.find(this.selector.pie_chart_container)

    this.created()
    this.bind_action()
  }

  protected created(){
    this.ajax_call_for_creating_or_updating_overview_and_graph()
  }

  protected bind_action(){
    this.month_range_select_menu.on("val_change", () => {
      this.ajax_call_for_creating_or_updating_overview_and_graph()
    })

    this.compare_section.on("val_change", () => {
      this.ajax_call_for_creating_or_updating_overview_and_graph()
    })

    this.$line_graph_container.on("mousemove mouseleave", (e) => {
      Highcharts.charts.forEach(chart => {
        if (chart == null) {
          return
        }

        if ( e.type === "mousemove" ) {
          this.onMouseMove(chart, e)
        }
        else {
          this.onMouseLeave(chart)
        }
      })
    })

    this.$bar_chart_container.on("mousemove mouseleave", (e) => {
      Highcharts.charts.forEach(chart => {
        if (chart == null) {
          return
        }

        if ( e.type === "mousemove" ) {
          this.onMouseMove(chart, e)
        }
        else {
          this.onMouseLeave(chart)
        }
      })
    })

  }

  protected searchPoint(event: any, chart: any) {
    const points = chart.series[0].points
    const x = chart.axes[0].toValue(event.chartX)
    const range = 0.5
    let   pointX

    for (let i = 0; i < points.length; i++) {
      pointX = points[i].x

      if ( pointX >= x - range && pointX < x + range ) {
        return points[i]
      }
    }
  }

  protected onMouseMove(chart: any, e: any) {
    // Find coordinates within the chart
    const custom_event = chart?.pointer.normalize(e)
    // Get the hovered point
    const current_point = this.searchPoint(custom_event, chart)

    if (current_point) {
      current_point.highlight(e)
    }
    else {
      chart.series.forEach(series => {
        series.points.forEach(point => {
          point?.onMouseOut()
          chart?.tooltip.hide(point)
          chart?.xAxis[0].hideCrosshair()
        })
      })
    }
  }

  protected onMouseLeave(chart: any) {
    chart.series.forEach(series => {
      series.points.forEach(point => {
        point?.onMouseOut()
        chart?.tooltip.hide(point)
        chart?.xAxis[0].hideCrosshair()
      })
    })
  }

  protected ajax_call_for_creating_or_updating_overview_and_graph(){
    const current_building_id = DataRetriever.get("building-id") as number
    const start_date = this.month_range_select_menu.start_date()
    const end_date = this.month_range_select_menu.end_date()
    const compare_option = this.compare_section.selected_compare_option()

    q_ajax_3({
      url:    Routes.api_web_app_real_estate_transaction_statistics_building_level_real_estate_transactions_page_index_path({
        locale:         I18n.locale,
        building_id:    current_building_id,
        start_date:     start_date,
        end_date:       end_date,
        is_rental:      false,
        compare_option: compare_option,
      }),
      method:   "GET",
      dataType: "json",
    })
    .then(({data, response}) => {
      if (data.data == null) {
        throw new Error(
          "data.data is null in " +
          "App.Pages.Buildings.Transactions.Components.TransactionAnalytics, " +
          `HTTP status code: ${response.status} ` +
          `data: ${data} `
        )
      }

      this.update_analytics_header_tiles(data.data)
      this.create_highchart_and_range_selector(data.data, compare_option)
      this.create_pie_charts(data.data)
    })
    .catch(({response}) => {
      // We noticed for some users the failure of ajax call with a returned status code 0
      // This failure might be due to a number of reason, external to our Rails app
      // For more information about the different reasons:
      // - http://stackoverflow.com/a/14507670/838346
      if (response.status === 0) { return }
      // Otherwise throw an error

      // Baiduspider-render issue
      if (response.status === 40) { return }
      if (response.status === 423) { return }

      // How to get HTTP status code from jQuery XHR obj:
      // - https://api.jquery.com/jQuery.ajax/#jqXHR
      // - https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/status
      throw new Error(
        "#ajax_call_for_updating_highcharts_graph failed in " +
        "App.Pages.Buildings.Transactions.Components.TransactionAnalytics, " +
        `HTTP status code: ${response.status || 0} ` +
        `with given textStatus message: ${response.statusText}`
      )
    })
  }

  protected update_analytics_header_tiles(data: any) {
    // region main data display

    const average_price_per_net_area = data.average_price_per_net_area
    const total_number_of_transactions = parseInt(data.total_number_of_transactions)
    const total_turnover = parseFloat(data.total_turnover)
    const total_turnover_label = NumbersFormatter.formattedNumberLabelForDisplay({
      value:            total_turnover,
      prefix:           "$",
      use_exact_value:  false,
    }) || ""

    if ( average_price_per_net_area > 0 ) {
      this.$average_price_per_net_area.text(`${data.currency_unit_for_display}${average_price_per_net_area.toLocaleString()}`)
      this.$suffix.show()
    }
    else {
      this.$average_price_per_net_area.text("-")
      this.$suffix.hide()
    }

    this.$total_number_of_transactions.text(total_number_of_transactions.toLocaleString())
    this.$total_turnover.text(total_turnover_label)

    // endregion main data display


    // region period comparison

    const show_percentage_different = this.compare_section.is_period_comparison_selected()
    const old_average_price_per_net_area = data.average_price_per_net_area_for_period_comparison
    const old_total_number_of_transactions = parseInt(data.total_number_of_transactions_for_period_comparison)
    const old_total_turnover = data.total_turnover_for_period_comparison

    this.comparison_in_overview_frame(average_price_per_net_area, old_average_price_per_net_area, this.$price_per_sqft_value_percentage_change, show_percentage_different)
    this.comparison_in_overview_frame(total_number_of_transactions, old_total_number_of_transactions, this.$total_transactions_percentage_change, show_percentage_different)
    this.comparison_in_overview_frame(total_turnover, old_total_turnover, this.$total_turnover_percentage_change, show_percentage_different)

    // endregion period comparison
  }

  protected create_highchart_and_range_selector(data: any, compare_option: string | null)  {
    const grouped_transaction_counts = data.grouped_transaction_counts
    const filtered_spacious_economic_indicator_data_entries = data.filtered_spacious_economic_indicator_data_entries

    const chart_date_label_format_type = data.chart_date_label_format_type
    const show_percentage_different = this.compare_section.is_period_comparison_selected()
    const show_comparison = this.compare_section.show_comparison()

    let offset_right = null

    if ( filtered_spacious_economic_indicator_data_entries.length > 0 ) {
      offset_right = 60
    }

    if ( this.$line_graph_container.length > 0 ) {
      if ( show_comparison ) {
        this.$line_graph_compare_series_symbol.show()
      }
      else {
        this.$line_graph_compare_series_symbol.hide()
      }

      if ( filtered_spacious_economic_indicator_data_entries.length > 0 ) {
        this.$economic_indicator_label.show()

        this.$line_graph_compare_series_text.hide()
        this.$line_graph_compare_series_text.filter(`[data-compare-option=${compare_option}]`).show()

        this.$economic_indicator_label_text.hide()
        this.$economic_indicator_label_text.filter(`[data-compare-option=${compare_option}]`).show()
      }
      else {
        this.$economic_indicator_label.hide()
        this.$line_graph_compare_series_text.hide()
        this.$economic_indicator_label_text.hide()
      }

      line_graph = LineGraph.create(this.$line_graph_container, data, compare_option, offset_right)
    }

    if (this.$bar_chart_container.length > 0) {
      bar_chart = BarChart.create(this.$bar_chart_container, data, show_percentage_different, offset_right != null ? offset_right + 20 : null)

      if ( show_percentage_different ) {
        this.$bar_chart_compare_series_symbol.show()
      }
      else {
        this.$bar_chart_compare_series_symbol.hide()
      }
    }

    const tickPositions: number[] = []
    const steps = Math.ceil(grouped_transaction_counts.length / 12)
    let i = 0

    while (i < grouped_transaction_counts.length) {
      tickPositions.push(i)
      i += steps
    }

    import(
      "highcharts/highstock"
    ).then((Highcharts) => {
      // Workaround for "Highcharts is not defined"
      window.Highcharts = Highcharts

      // https://stackoverflow.com/questions/69895775/how-can-you-combine-multiple-graphs-and-control-with-one-range-selector-with-hig
      Highcharts.stockChart(this.$range_selector_container[0] as Highcharts.HTMLDOMElement, {
        chart: {
          marginLeft:   100,
          marginRight:  offset_right,
          spacingLeft:  0,
          height:       80,
        },
        credits: {
          enabled: false,
        },

        navigator: {
          outlineWidth: 0,
          handles:      {
            backgroundColor: "#406599",
          },
          xAxis: {
            ordinal:    false,
            categories: grouped_transaction_counts.map(({first_day_of_period}) => {
              const prefix = chart_date_label_format_type === "Q YYYY" ? "Q" : ""

              return [
                prefix,
                dayjs(first_day_of_period).add(0, "month").locale(I18n.locale.toLowerCase()).format(chart_date_label_format_type),
              ].join("")
            }),
            min:      0,
            minRange: 0.00000001,
            labels:   {
              rotation:     0,
              reserveSpace: true,
              enabled:      true,
              useHTML:      true,
              align:        "center",
              x:            0,
              y:            20,
              style:        {
                fontSize:     10 + "px",
                whiteSpace:   "nowrap",
                textOverflow: "none",
              },
            },
            tickmarkPlacement: "on",
            gridLineDashStyle: "ShortDot",
            tickPositions:     tickPositions,
          },
          yAxis: {
            min: 0,
            max: Math.max(...grouped_transaction_counts.map((e) => e.transaction_count)) < 10 ? 10 : null,
          },
        },

        yAxis: {
          min:      0,
          max:      Math.max(...grouped_transaction_counts.map((e) => e.transaction_count)) < 10 ? 10 : null,
          visible:  false,
          events:   {
            afterSetExtremes: function(e) {
              const max= e.dataMax > 0 ? null : 30000

              line_graph.yAxis[0].update({max: max})
            },
          },
        },
        xAxis: {
          visible:  false,
          minRange: 0.000001,
          events:   {
            afterSetExtremes: function(e) {
              line_graph.xAxis[0].setExtremes(e.min, e.max, true, false)
              bar_chart.xAxis[0].setExtremes(e.min, e.max, true, false)
            },
          },
          tickInterval: Math.ceil(grouped_transaction_counts.length / 12),
        },

        series: [{
          type:       "line",
          color:      "rgba(233, 238, 243, 1)",
          fillColor:  {
            linearGradient: [0, 0, 0, 300],
            stops:          [
              [0, "#E9EEF3"],
              [1, "#E9EEF3"],
            ],
          },
          data:    grouped_transaction_counts.map((e) => {
            return {
              y:      e.transaction_count,
              marker: {
                enabled: false,
                states:  {
                  hover: {
                    enabled: false,
                  },
                },
              },
            }
          }),
        }],

      })
    })
  }

  protected create_pie_charts(data: any) {
    this.$pie_charts_container.hide()

    if (parseInt(data.total_number_of_transactions, 10) > 0) {
      this.$pie_charts_container.show()

      this.$pie_chart_container.each((_idx, el) => {
        const chart_name = $(el).attr("type") as string

        PieChart.create(this.$pie_chart_container, data, chart_name)
      })
    }
  }

  protected comparison_in_overview_frame(new_value: number | null, old_value: number | null, $target_el: JQuery<HTMLElement>, show_percentage_different: boolean) {
    $target_el.removeClass("positive-growth")
    $target_el.removeClass("negative-growth")

    if ( new_value == null || old_value == null || !show_percentage_different) {
      return
    }

    const percentage_diff = (new_value - old_value) / old_value
    const percentage_label = Number(percentage_diff).toLocaleString(I18n.locale,{style: "percent", minimumFractionDigits: 1, maximumFractionDigits: 1})

    if ( new_value === 0 && old_value === 0 ) {
      $target_el.addClass("positive-growth")
      $target_el.text("+0.0%")
    }
    else if ( percentage_diff >= 0 ) {
      $target_el.addClass("positive-growth")
      $target_el.text(`+${percentage_label}`)
    }
    else {
      $target_el.addClass("negative-growth")
      $target_el.text(`${percentage_label}`)
    }
  }

}


const Factory = {
  _instance: null as null | MarketDataOverview,

  instance(selector?: InputSelector){
    if (this._instance != null) { return this._instance }

    this._instance = this.create(selector)
    return this._instance
  },
  create(selector?: InputSelector){
    return new MarketDataOverview(selector)
  },
}


export {
  Factory,
  MarketDataOverview,
}
